export default "__VITE_ASSET__1f1dee25__"